
import { defineComponent } from "vue";
import Home from "@/views/home.vue"; // @ is an alias to /src

export default defineComponent({
  name: "loginView",
  components: {
    Home,
  },
  setup(props, ctx) {},
});
